<template>
    <div class="contact pa-1">
        <v-row class="no-frame text-row" v-if="!contact">
            <v-col class="no-frame col-6 pr-1">
                <div class="name-box">&nbsp;</div>
            </v-col>
            <v-col class="no-frame col-6 right pr-1">
                <div class="name-box"></div>
            </v-col>
        </v-row>
        <v-row class="no-frame text-row" v-if="contact">
            <v-col class="no-frame col-6 pr-1">
                <!-- contact names -->
                <v-tooltip
                    content-class = "custom-tooltip white"
                    :open-delay   = "openDelay"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                            class  = "name-box"
                        >
                            <f-copy-text color="white--text" :text="name (contact)" class="copy-text"/>
                        </div>
                    </template>

                    <div class="lm-border primary-border-thick pa-2">
                        <div
                            v-for = "(name, index) in contact.names"
                            :key  = "index"
                            class = "tooltip-name"
                        >
                            {{ name }}
                        </div>
                    </div>
                </v-tooltip>
                <!-- contact names -->
            </v-col>

            <v-col class="no-frame col-6 right pr-1">
                <!-- contact company -->
                <v-tooltip
                    content-class = "custom-tooltip white"
                    :open-delay   = "openDelay"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                            class  = "name-box"
                        >
                            <f-copy-text color="white--text"  :text="contact.company.name"  class="w-100 right copy-text"/>
                        </div>
                    </template>

                    <div class="lm-border primary-border-thick pa-2 right">
                        <div class = "tooltip-name">
                            {{ contact.company.name }}
                        </div>
                    </div>
                </v-tooltip>
                <!-- contact company -->
            </v-col>
        </v-row>
        <v-row class="no-frame text-row" v-if="contact" style="height: 18px;">
            <v-col class="no-frame pl-1">
                <f-copy-text  color="black--text" :text="phone" />
            </v-col>

            <v-col class="no-frame right pr-1">
                <f-copy-text color="black--text" :text="mobile" :right="true" />
            </v-col>
        </v-row>

        <v-row class="no-frame text-row" v-if="contact">
            <v-col class="no-frame">
                <v-tooltip
                    content-class = "custom-tooltip white"
                    :open-delay   = "openDelay"
                    bottom
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            class="v-flex"
                            v-bind = "attrs"
                            v-on   = "on"
                        >
                            <f-copy-text
                                :text = "contact.email"
                                color="black--text"
                            />
                            <a @click="onMail" class="black--text">
                                <div class="mr-1 ml-n1 w-100 contact-mail" style="margin-top: -1px"><v-icon color="primary">mdi-email</v-icon></div>
                            </a>
                        </div>
                    </template>

                    <div class="lm-border primary-border-thick pa-2">
                        <div
                            v-for = "(email, index) in contact.emails"
                            :key  = "index"
                            class = "tooltip-name v-flex"
                        >
                            <div style="margin-top: -1px" class="pr-1">
                                <v-icon :color="email.valid? 'primary':'error'">mdi-email</v-icon>
                            </div>
                            <div :class="email.valid?'':'error--text'">{{ email.address }}</div>
                        </div>
                    </div>
                </v-tooltip>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import FCopyText from "@/modules/core/components/utils/FCopyText";
import Core from "@/modules/core/service/Core";
import {AsYouType} from "libphonenumber-js";

export default {
    name: "CSiteContact",

    components: {
        FCopyText
    },

    props: {
        contact: {
            required: false,
            type    : Object,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        openDelay: 500,
    }),

    computed: {
        phone () {
            return this.phonenumber (1);
        },

        mobile () {
            return this.phonenumber (2);
        },
        countries () {
            return this.$store.getters ['msd']['countries'];
        }
    },

    methods: {
        onMail () {
            this.$bus.$emit(this.$events.mail, this.contact);
        },

        phonenumber (type) {
            const phonenumbers = this.contact.phonenumbers;
            if (!phonenumbers) {
                return null;
            }

            const number = phonenumbers.find(phone => phone.type.id === type);
            if (!number) {
                return null;
            }

            return this.phoneX(number.number);
        },

        name (contact) {
            return contact.firstname ? contact.firstname + " " + contact.name : contact.name;
        },

        unicode (number) {
            let unicode = Core.message.language();

            if (number.startsWith("+")) {
                const countryPhone = number.substr(0, 3);
                const country = this.countries.find (c => c.phone === countryPhone);
                if (country) {
                    return country.iso3166;
                }
            }

            return unicode;
        },

        phoneX (number) {
            let unicode = this.unicode(number);
            if (unicode) {
                return new AsYouType(unicode).input(number);
            }

            return number;
        }

    }
}
</script>

<style scoped>

.text-row {
    line-height: 18px
}

.contact {
    width: 100%;
    height: 60px;
    background-color: white;
    color: black;
    border-radius: 2px;
    font-size: 14px;
}

.contact-mail {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 4px;
}

.right {
    text-align: right;
}

.copy-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}



</style>

<style lang="scss" scoped>
.custom-tooltip {
    opacity: var(--v-tooltip-opacity, 1.0) !important;
    padding: 0!important;
}

.tooltip-name {
    color: var(--v-primary-base);
}

.name-box {
    background-color:  var(--v-primary-base);
    color: white!important;
    border-radius: 3px;
    padding-left: 4px;
    height: 18px;
}

</style>